import { Avatar, AvatarFallback } from "@/ui/avatar";

interface AdcUserAvatarProps {
  name: string;
  email: string;
  role: string;
}

const getInitials = (name: string) => {
  const normalized = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // @ts-ignore
  const initials = normalized.match(/(?:(?<=^)|(?<=\s))\p{L}/gu);
  return initials?.join("").substring(0, 2).toUpperCase() ?? "";
};

export const AdcUserAvatar = ({ name, email, role }: AdcUserAvatarProps) => {
  return (
    <div className="flex items-center gap-3">
      <Avatar>
        <AvatarFallback>{getInitials(name)}</AvatarFallback>
      </Avatar>
      <div className="flex flex-col items-start text-left max-md:hidden">
        <span className="text-sm text-white">{email}</span>
        <span className="text-xs text-white/70">{role}</span>
      </div>
    </div>
  );
};
